
import slider3 from "../assets/Resim14.png";

const Girisimcilik  = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Girişimcilik</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>Teknokent bünyesinde faaliyet gösteren Kuluçka Merkezi düzenli olarak ziyaret edilmekte ve Kuluçka Merkezi’nde yer alan firmaların Yönetici Şirket’e projelerinin gelişimi hakkında bilgi vermeleri teşvik edilmektedir. Bu kapsamda kuluçka merkezinde yer alan firmalara talepleri doğrultusunda danışmanlık ve mentorluk hizmetleri sunulmaktadır. İhtiyaçları analiz edilerek uygun seminer ve eğitimler ile öncelikle ticarileşmeleri, daha sonra da uluslararasılaşmaları desteklenmektedir. Bu amaçla desteklerin başlıcaları şunlardır;</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-10">
          <ul>
            <li>İlgili eğitim, seminer ve atölyelerin düzenlenmesi </li>
            <li>Yarışma ve benzeri girişimciliği teşvik edici programların organize edilmesi </li>
            <li>Yönetim desteği, kritik iş ve teknik desteklerin verilmesi </li>
            <li>Teknik ve idari konularda danışmanlık ve mentorluk hizmetlerinin sağlanması </li>
            <li>Şirketleşme, ticarileşme, uluslararasılaşma ve benzeri alanlarda desteklerin sağlanması </li>
            <li>Ar-Ge ve yenilik faaliyetleri ile tasarım faaliyetleri ile ilgili finansmana erişim konusunda danışmanlık sunulması ve mevcut programlara yönlendirilmesi veya uygun yapılar ile bir araya gelinmesine destek olunması</li>
            <li>Kuluçka firmalarının kendi aralarında ve Bölgede yerleşik diğer firmalarla etkileşim ve iş birliklerinin sağlanması </li>
            <li>Ofis imkanı, mobilya ve ekipman sağlanması, ihtiyaç duyulan altyapının ve ortak mekanların oluşturulması </li>
            <li>Sekretarya ve destek hizmetlerinin sunulması, donanım ve yazılımlara erişimin sağlanması </li>
          </ul>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12">
          <p>Kuluçka Merkezi, yasal tanımına uygun olarak en fazla üç yıllık, yenilikçi ve ticarileşme potansiyeli yüksek Ar-Ge projesi sahibi girişimcileri hedeflemektedir. Başvuruların değerlendirilmesinde, POLSAN Teknokent’in stratejik odak alanı olan güvenlik teknolojileri ve bu ekosistemi destekleyici tamamlayıcı teknolojilerle uyum ve sinerji potansiyeli, önemli bir kriter olarak göz önünde bulundurulmaktadır.</p>
          <p>Yönetici Şirket, Kuluçka Merkezi aracılığıyla genç işletmeleri sadece barındırmayı değil, onları aktif olarak geliştirmeyi misyon edinmektedir.</p>
          <p>POLSAN Teknokent’in ana kampüsü dışında kurulacak kuluçka merkezlerinde yer alacak girişimcilerin, yasal mevzuata tam uyumlu olarak 10 kişiden az personele sahip ve son üç yıl içerisinde kurulmuş olması şartı aranır.</p>
          <p>Kuluçka firmalarına, proje süreleri esas alınarak en fazla 36 aya kadar yer tahsisi yapılır. Bu süre boyunca firmaların gelişimi; ciro, patent başvurusu, ihracat, alınan yatırım ve personel sayısı gibi somut performans kriterleri ile periyodik olarak izlenir. Performans hedeflerine ulaşan firmaların gelişimleri desteklenir.</p>
          <p>Henüz şirketleşmemiş ancak yenilikçi bir iş fikrine sahip girişimcilere, fikirlerini doğrulamaları ve iş modellerini geliştirmeleri için en fazla 18 ay süreli Ön Kuluçka Programı imkânı sunulur. Bu program, en erken aşamadaki yenilikleri ekosisteme kazandırmayı hedefler.</p>
          <p>Kuluçka Merkezi’nde yer kalmaması durumunda, BDBK tarafından kabul edilmiş yüksek potansiyelli kuluçka firmalarına veya ön kuluçka girişimcilerine, diğer binalarda bulunan uygun ofis alanları tahsis edilebilir.</p>
          <p>Kuluçka girişimcilerine, "erişilebilir olma" vizyonu doğrultusunda ve yasal çerçeveye tam uyumlu olarak indirimli kira tarifesi uygulanır. Bu tarife, kamu destekli projeler için bölge kira bedelinin %25'ini, diğerleri için ise %50'sini aşamaz.</p>
          <p>Bu bölümde belirtilen tüm kurallar, destekler, teşvikler ve politikalar, Yönetici Şirket tarafından bölge dışında açılacak kuluçka merkezleri için de aynen geçerli olacaktır.</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-8 col-sm-12 mb-4">
          <img src={slider3} alt="Girisimcilik" className="img-fluid" />
        </div>
      </div>

    </>
  );
};

export default Girisimcilik;
